import { useQuery } from 'react-query'
import compress from 'graphql-query-compress'
import { MagentoIsEmailAvailableOutput } from 'lib/types'
import { axiosClient } from 'lib/core/services/magento/client'

interface EmailAvailable {
  isFetching: boolean
  emailIsAvailable: boolean
}

const query = (email?: string) => `
  {
    isEmailAvailable(email: "${encodeURIComponent(email ?? '')}") {
      is_email_available
    }
  }
`

interface Response {
  data: {
    isEmailAvailable: null | MagentoIsEmailAvailableOutput
  }
}

export const useEmailIsAvailable = (email?: string): EmailAvailable => {
  const { data, isFetching } = useQuery(['useEmailIsAvailable', email], async () => {
    return axiosClient(compress(query(email)))
  }, {
    enabled: Boolean(email)
  })

  const res = data?.data as Response | undefined
  const value = res?.data.isEmailAvailable?.is_email_available
  const emailIsAvailable = value ?? true

  return {
    isFetching,
    emailIsAvailable
  }
}
